import Nullstack from 'nullstack';
export default function IconWindsock({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-windsock",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 3v18"
  }), "   ", Nullstack.element("path", {
    d: "M6 11l12 -1v-4l-12 -1"
  }), "   ", Nullstack.element("path", {
    d: "M10 5.5v5"
  }), "   ", Nullstack.element("path", {
    d: "M14 6v4"
  }), "   ", Nullstack.element("path", {
    d: "M4 21h4"
  }), " ");
}